import {
	payoneerGateways,
	getPaymentBox,
	getComponentNameFromPaymentBox,
} from './woocommerce';

export const applyComponentListChange = function (
	sdk,
	changeInfo,
	componentsList
) {
	initNewComponents( sdk, changeInfo.availableComponents, componentsList );
	removeRemovedComponents(
		sdk,
		changeInfo.removedComponents,
		componentsList
	);
	hidePayoneerGatewaysWithoutComponents( componentsList, payoneerGateways() );
};

const { paymentFieldsComponentAttribute } = window.PayoneerData;

export const mountComponents = ( components, sdk ) => {
	for ( const [ componentName, component ] of Object.entries( components ) ) {
		const container = findComponentContainer( componentName );
		if (
			container instanceof Element &&
			sdk.isAvailable( componentName )
		) {
			component.mount( container );
		}
	}
};

const initNewComponents = function (
	sdk,
	availableComponents,
	componentsList
) {
	availableComponents.forEach( ( componentName ) => {
		if (
			! sdk.isDroppedIn( componentName ) &&
			typeof findComponentContainer( componentName ) === 'object'
		) {
			try {
				componentsList[ componentName ] = sdk.dropIn( componentName, {
					hidePaymentButton: true,
				} );
			} catch ( e ) {
				console.log(
					`Failed to drop in component ${ componentName }. Error details: ${ e }`
				);
			}
			return;
		}

		console.log(
			`Component ${ componentName } already dropped in. Skipping.`
		);
	} );
};

const removeRemovedComponents = function (
	sdk,
	removedComponents,
	componentsList
) {
	removedComponents.forEach( ( componentName ) => {
		delete componentsList[ componentName ];
		if ( sdk.isDroppedIn( componentName ) ) {
			sdk.remove( componentName );
		}
	} );
};

const findComponentContainer = function ( componentName ) {
	return document.querySelector(
		`[${ paymentFieldsComponentAttribute }=${ componentName }]`
	);
};

const hidePayoneerGatewaysWithoutComponents = function (
	componentsList,
	payoneerGateways
) {
	for ( const gatewayId of payoneerGateways ) {
		const componentName = getComponentNameFromPaymentBox(
			getPaymentBox( gatewayId )
		);
		if ( componentsList[ componentName ] === undefined ) {
			findComponentContainer( componentName ).closest(
				'li.wc_payment_method'
			).style.display = 'none';
		}
	}
};
